import { render, staticRenderFns } from "./WechatMenu.vue?vue&type=template&id=2bb79b0b&"
import script from "./WechatMenu.vue?vue&type=script&lang=js&"
export * from "./WechatMenu.vue?vue&type=script&lang=js&"
import style0 from "./WechatMenu.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports